export enum ResolveConflictOption {
  DISABLE_PREVIOUS = 'DISABLE_PREVIOUS',
  DISABLE_CURRENT = 'DISABLE_CURRENT',
}
